// extracted by mini-css-extract-plugin
export default {"shake":"G5ac5bd","textarea":"Gd72f39"};